/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFSecReviewTaskType = {
    Bootstrap: 'bootstrap',
    Builtwith: 'builtwith',
    Dataleaks: 'dataleaks',
    Enumeration: 'enumeration',
    Honeypots: 'honeypots',
    PdfGeneration: 'pdf_generation',
    Privacy: 'privacy',
    ScanHistorical: 'scan_historical',
    ScanQuick: 'scan_quick',
    ScanSe: 'scan_se',
    ScanWeb: 'scan_web',
    SecurityDecisions: 'security_decisions',
    SecurityFindings: 'security_findings',
    Sourcelists: 'sourcelists',
    Spiders: 'spiders',
    Summary: 'summary',
    TechExtraction: 'tech_extraction',
    Torrents: 'torrents',
    TxtGeneration: 'txt_generation',
    Virustotal: 'virustotal',
    Wappalyzer: 'wappalyzer',
    SecurityAnalysis: 'security_analysis',
    DatamartTechs: 'datamart_techs',
    DatamartFindings: 'datamart_findings',
    DatamartExtFindings: 'datamart_ext_findings'
} as const;
export type CRSFSecReviewTaskType = typeof CRSFSecReviewTaskType[keyof typeof CRSFSecReviewTaskType];


export function CRSFSecReviewTaskTypeFromJSON(json: any): CRSFSecReviewTaskType {
    return CRSFSecReviewTaskTypeFromJSONTyped(json, false);
}

export function CRSFSecReviewTaskTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewTaskType {
    return json as CRSFSecReviewTaskType;
}

export function CRSFSecReviewTaskTypeToJSON(value?: CRSFSecReviewTaskType | null): any {
    return value as any;
}

